import { notFound } from 'next/navigation';
import { ProductReduxClient } from './product-redux.client';
// import { notFound } from 'next/navigation';
interface ProductReduxServerProps {
  promise: Promise<any>;
}

export async function ProductReduxServer(props: ProductReduxServerProps) {
  const { promise } = props;
  try {
    const productData = await promise;
    return <ProductReduxClient productData={productData} />;
  } catch (error) {
    notFound();
  }
}

export default ProductReduxServer;
